// SPDX-FileCopyrightText: 2026 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import React, { useState } from 'react';
import { NotificationBanner } from '@tls/treact-ui';
import { bannerKey, type BannerDto } from 'model/Banner';

export default function AppBanner({ banner }: Readonly<{ banner?: BannerDto | null }>) {
  const [dismissedKey, setDismissedKey] = useState<string | null>(null);

  if (!banner) return null;

  const key = bannerKey(banner);
  if (banner.isDismissable && dismissedKey === key) return null;

  return (
    <NotificationBanner
      kind={banner.severity}
      title={banner.title}
      description={banner.info}
      onClose={banner.isDismissable ? () => setDismissedKey(key) : undefined}
      data-testid='app-banner'
    />
  );
}
